import { action, observable, makeObservable } from 'mobx';

class GameStore {
  odd = 0;

  hasAutoBet = false;

  oddsInfo = [];

  replayData = null;

  isReplayWatchAgain = false;

  spinResult = {};

  noWinMatrix = [];

  isSpinStart = false;

  isExpandWildOpen = false;

  gameInitialMatrix = [];

  isNeedGetBalance = false;

  isNeedSpinAction = false;

  constructor() {
    makeObservable(this, {
      odd: observable,
      replayData: observable,
      noWinMatrix: observable,
      hasAutoBet: observable,
      isSpinStart: observable,
      isReplayWatchAgain: observable,
      oddsInfo: observable.deep,
      spinResult: observable.deep,
      isExpandWildOpen: observable,
      isNeedSpinAction: observable,
      isNeedGetBalance: observable,
      gameInitialMatrix: observable.deep,
      setOdd: action.bound,
      setHasAutoBet: action.bound,
      setOddsInfo: action.bound,
      setSpinResult: action.bound,
      setReplayData: action.bound,
      setIsSpinStart: action.bound,
      setNoWinMatrix: action.bound,
      setIsNeedSpinAction: action.bound,
      setIsNeedGetBalance: action.bound,
      setIsExpandWildOpen: action.bound,
      setGameInitialMatrix: action.bound,
      setIsReplayWatchAgain: action.bound,
    });
  }

  setReplayData(data) {
    this.replayData = data;
  }

  setHasAutoBet(bool) {
    this.hasAutoBet = bool;
  }

  setIsExpandWildOpen(bool) {
    this.isExpandWildOpen = bool;
  }

  setIsReplayWatchAgain(bool) {
    this.isReplayWatchAgain = bool;
  }

  setIsNeedSpinAction(bool) {
    this.isNeedSpinAction = bool;
  }

  setIsNeedGetBalance(bool) {
    this.isNeedGetBalance = bool;
  }

  setNoWinMatrix(matrix) {
    this.noWinMatrix = matrix;
  }

  setOdd(value) {
    this.odd = value;
  }

  setSpinResult(spinResult) {
    this.spinResult = spinResult;
  }

  setGameInitialMatrix(matrix) {
    this.gameInitialMatrix = matrix;
  }

  setOddsInfo(oddsInfo) {
    this.oddsInfo = oddsInfo;
  }

  setIsSpinStart(bool) {
    this.isSpinStart = bool;
  }
}

export const gameStore = new GameStore();
